
import './ToolsBarItem.scss'

import { ReactComponent as FlyersIcon }     from '../../../../assets/toolsBar/flyers_icon.svg'
import { ReactComponent as PagesIcon }      from '../../../../assets/toolsBar/pages_icon.svg'
import { ReactComponent as SpotsIcon }      from '../../../../assets/toolsBar/spots_icon.svg'
import { ReactComponent as PromotionsItemsIcon } from '../../../../assets/toolsBar/promotions_items_icon.svg'
// import { ReactComponent as ItemsIcon }      from '../../../../assets/toolsBar/items_icon.svg'
import React from "react";
// import {
//     dispatchEventDataType,
//     EVENT_DATA_TYPE_DISABLE_TABS
// } from "../../../../globals/EventDispatcher";


interface IToolsBarItem {
    index: number;
    title: string;
    onClick: (index: number) => void;
    selected: boolean;
    isAboveTheSelected: boolean;
    isBelowTheSelected: boolean;
    isDisabledTab?: boolean;
    titleForBtn?: string
}

export const ToolsBarItem: React.FC<IToolsBarItem> = (props) => {

    let containerClass = ''
    let imgClass = '';

    if(props.selected){
        containerClass = 'item_selected'
        imgClass = 'svg_icon_selected'
    }
    else {
        containerClass = 'item_unselected'
        imgClass = 'svg_icon_unselected'
    }

    let backClass = ''
    let frontClass = ''

    if(props.isAboveTheSelected){
        backClass = 'above_selected_back_layer'
        frontClass = 'above_selected_front_layer'
    }

    if(props.isBelowTheSelected){
        backClass = 'below_selected_back_layer'
        frontClass = 'below_selected_front_layer'
    }

    let disabledStyle = '';
    if(props.isDisabledTab && !props.selected){
        disabledStyle = `disabled_tab`;
    }

    return (
        <div
            title={props.titleForBtn || ""}
            className={`tools_bar_item_container ${containerClass} ${disabledStyle}`}
            onClick={() => {
                // if(props.title === "Flyers"){
                //     dispatchEventDataType(EVENT_DATA_TYPE_DISABLE_TABS, true)
                // }
                if(disabledStyle === ""){
                    props.onClick(props.index)
                }
            }}
            >
                <div className={`bg_color_container_back  ${backClass}`}>

                </div>
                <div className={`bg_color_container_front ${frontClass}`}>
                    
                </div>

                <div className={`tools_bar_item_content`}>
                    {props.index === 0 && <FlyersIcon     className={imgClass} />}
                    {props.index === 1 && <PagesIcon      className={imgClass} />}
                    {props.index === 2 && <SpotsIcon      className={imgClass} />}
                    {props.index === 3 && <PromotionsItemsIcon className={imgClass} />}
                    {/*{props.index === 4 && <ItemsIcon      className={imgClass} />}*/}
                    <p>{props.title}</p>
                </div>
        </div>
    )
}